import FAQRepository from "./../api/index"
import "../types"
import FAQEnum from "../constants/options";

class FAQUseCase {
    constructor() {
        /** @type {FAQRepository}*/
        this.api = new FAQRepository()
    }

    /**
     *
     * @param reqFAQ {RequestFAQ}
     * @return {{err: string, message: string}|{err: null, message: string}}
     * @private
     */
    _validateRequest(reqFAQ) {
        if (reqFAQ.category.length === 0) {
            return {err: "required category", message: ""}
        }
        if (reqFAQ.topic.length === 0) {
            return {err: "required topic", message: ""}
        }
        if (reqFAQ.answer.length === 0) {
            return {err: "required answer", message: ""}
        }
        if (reqFAQ.question.length === 0) {
            return {err: "required question", message: ""}
        }
        if (reqFAQ.priority < 0 || reqFAQ.priority > 1000) {
            return {err: "required priority > 0 and < 1001", message: ""}
        }
        return {err: null, message: ""}
    }

    /**
     *
     * @param reqFAQ {RequestFAQ}
     * @return {Promise<{err: null, message: string}|{err: string, message: string}|{err: *, message: null}>}
     */
    async createOne(reqFAQ) {
        const {err} = this._validateRequest(reqFAQ)
        if (err) {
            return {err, message: ""}
        }
        return await this.api.createOne(reqFAQ)
    }

    /**
     *
     * @param id {number}
     * @return {Promise<{data: FAQ, err: null}|{data: null, err: string}|{data: null, err: *}>}
     */
    async getOne(id) {
        return this.api.getOneByID(id)
    }

    /**
     *
     * @param id {number}
     * @return {Promise<{err: null, message: string}|{err: string, message: string}|{err: *, message: null}>}
     */
    async setStatusInactive(id) {
        const req = {status: "INACTIVE"}
        return this.api.updateOneByID(id, req)
    }

    /**
     *
     * @param id {number}
     * @param reqFaq {RequestFAQ}
     * @return {Promise<{err: null, message: string}|{err: string, message: string}|{err: *, message: null}>}
     */
    async updateOne(id, reqFaq) {
        reqFaq.priority = +reqFaq.priority
        const {err} = this._validateRequest(reqFaq)
        if (err) {
            return {err, message: ""}
        }
        if (reqFaq.priority === 0) {
            reqFaq.priority = null
        }
        return this.api.updateOneByID(id, reqFaq)
    }

    /**
     *
     * @param faqData {RequestFAQ}
     * @param optionsTopic {Array<{label: string, value: string}>}
     * @return {RequestFAQ}
     */
    setTopicOnChangeCategory(faqData, optionsTopic) {
        let isMatchTopic = false
        FAQEnum.ALL_OPTIONS[faqData.category].forEach(v => {
            if (v.value === faqData.topic) {
                isMatchTopic = true
            }
        })
        if (!isMatchTopic) {
            faqData.topic = optionsTopic[0].value
        }
        return faqData
    }

    /**
     *
     * @param queries {string}
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        try {
            let finalQueries = ""
            if (queries && queries.length > 0) {
                finalQueries += "?" + queries
            }
            const resp = await this.api.getAll(finalQueries)
            if (resp.data && resp.data.length > 0) {
                resp.data.forEach(v => {
                    v.topic = v.topic.split("-").join(" ")
                    if (!v.priority) {
                        v.priority = "-"
                    }
                })
            }
            return resp
        } catch (err) {
            return err
        }
    }

}

export default new FAQUseCase()
